import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const BASE_URL = process.env.REACT_APP_BASE_URL;





// Async thunks
export const getStudyMaterials = createAsyncThunk(
  "studyMaterials/getStudyMaterials",
  async (params = {}) => {
    try {
      const page = typeof params === 'object' ? (params.page || 1) : params;
      const perPage = typeof params === 'object' ? (params.per_page || 10) : 10;
      const search = typeof params === 'object' ? (params.search || "") : "";
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(
        `${BASE_URL}/dashboard/subjects?page=${page}&per_page=${perPage}&search=${encodeURIComponent(search)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return message;
    }
  }
);
export const addStudyMaterial = createAsyncThunk(
  "studyMaterials/addStudyMaterial",
  async (materialData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/subjects`,
        materialData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "فشل في الإضافة");
    }
  }
);
export const subjectRecord = createAsyncThunk(
  "studyMaterials/subjectRecord",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/subjects/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue({ message });
    }
  }
);
export const updateStudyMaterial = createAsyncThunk(
  "studyMaterials/updateStudyMaterial",
  async ({ id, materialData }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/subjects/${id}/update`,
        materialData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "فشل في التحديث");
    }
  }
);

// Delete subjects
export const deleteSubjects = createAsyncThunk(
  "subjects/deleteSubjects",
  async (id, thunkAPI) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.delete(
        `${BASE_URL}/dashboard/subjects/${id}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return {
        message: response.data?.message || "subjects deleted successfully",
        id: id,
        success: true,
      };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف المادة";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  studyMaterials: [],
  Subjects: null,
  meta: null,
  record: null,
  loading: false,
  error: null,
  success: null,
  deleteSuccessMessage: null,
};

const studyMaterialsSlice = createSlice({
  name: "studyMaterials",
  initialState,
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Study Materials
      .addCase(getStudyMaterials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStudyMaterials.fulfilled, (state, action) => {
        state.loading = false;
        state.studyMaterials = action.payload.data;
        state.meta = action.payload.meta;
        state.error = null;
      })
      .addCase(getStudyMaterials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Study Material
      .addCase(addStudyMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addStudyMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message || "تم إضافة المادة بنجاح";
        state.error = null;
      })
      .addCase(addStudyMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Subjects
      .addCase(deleteSubjects.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccessMessage = null;
      })
      .addCase(deleteSubjects.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccessMessage = action.payload.message;
        state.deleteError = null;
        state.studyMaterials = state.studyMaterials.filter(
          (Subjects) => Subjects.id !== action.payload.id
        );
      })
      .addCase(deleteSubjects.rejected, (state, action) => {
        state.deleteError = action.payload;
        state.deleteSuccessMessage = null;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete grades";
      })
      // update study Materials
      .addCase(updateStudyMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;

      })
      .addCase(updateStudyMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(updateStudyMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(subjectRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(subjectRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.record = action.payload.data;
      })
      .addCase(subjectRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add data";
      });
  },
});

export const { clearState } = studyMaterialsSlice.actions;
export default studyMaterialsSlice.reducer;
